import React, { FC, useEffect, useState } from 'react'
import clsx from 'clsx'

import { sortByTotalPoints, sortResultsByTime } from '../../../../data/operations-tab-utils'
import { httpService } from '../../../../../../../../services/httpService'

import { IRegistrationByDayEx } from '../../../../ManageClinicNOtherOperationsTab'

import { IRegistrationByDayInterface } from '../../../../../../../../models/registrations-by-day/registrationByDay.interface'
import { RegistrationFeesType } from '../../../../../../../../models/event-fees/event-fees.interface'

interface TotalPointsInputProps {
  row: IRegistrationByDayEx
  setRegistrationsByDay: (value: IRegistrationByDayInterface[]) => void
  registrationsByDay: IRegistrationByDayInterface[]
  fee?: RegistrationFeesType | null
}

export const TotalPointsInput: FC<TotalPointsInputProps> = ({
  row,
  setRegistrationsByDay,
  registrationsByDay,
  fee,
}) => {
  const [totalPoints, setTotalPoints] = useState('')

  const onBlurTotalPoints = async (event: any, row: IRegistrationByDayInterface) => {
    const value = event.target.value
    const valueWithoutLeadingZeros = value === '0' ? value : value.replace(/^0+/, '')
    setTotalPoints(valueWithoutLeadingZeros)

    let current: IRegistrationByDayInterface

    // get the current registration by day
    const registrationsByDayUpdated: IRegistrationByDayInterface[] =
      registrationsByDay?.map((registrationByDay) => {
        if (registrationByDay.id === row.id) {
          const updated = {
            ...registrationByDay,
            score: {
              ...registrationByDay.score,
              totalPoints: valueWithoutLeadingZeros,
            },
          }
          current = updated
          return updated
        } else {
          return registrationByDay
        }
      }) ?? []

    let sortedRegistrationsUpdated: IRegistrationByDayInterface[]
    const scoreCardType = row.score?.judges?.[0]?.scoreCardType
    if (scoreCardType === 'fastest') {
      sortedRegistrationsUpdated = sortResultsByTime(
        registrationsByDayUpdated,
        fee?.isAsc ? 'asc' : 'desc',
        'fastest'
      )
    } else if (scoreCardType === 'optimum') {
      sortedRegistrationsUpdated = sortResultsByTime(
        registrationsByDayUpdated,
        fee?.isAsc ? 'asc' : 'desc',
        'optimal'
      )
    } else {
      sortedRegistrationsUpdated = sortByTotalPoints(
        registrationsByDayUpdated,
        fee?.isAsc ? 'asc' : 'desc'
      )
    }

    let count = 0

    // update rank for all registrations that have the same class
    const registrationsByDayToUpdate: IRegistrationByDayInterface[] = []
    sortedRegistrationsUpdated?.forEach((registrationByDay) => {
      if (current.uuid === registrationByDay.uuid) {
        count++
        const current = {
          ...registrationByDay,
          ...(registrationByDay.score && {
            score: { ...registrationByDay.score, rank: count },
          }),
        }
        registrationsByDayToUpdate.push(current)
        return current
      }
    })

    // Update firestore collection on BE by batch
    if (registrationsByDayToUpdate?.[0]) {
      const registrationsByDayNew = registrationsByDayUpdated.map((item) => {
        const current = registrationsByDayToUpdate.find((current) => current.id === item.id)
        if (current) return current
        else return item
      })
      setRegistrationsByDay([...registrationsByDayNew])
      await httpService({
        url: 'update_registrations_by_day',
        method: 'POST',
        data: {
          registrationsByDay: registrationsByDayToUpdate,
        },
      })
    }
  }

  useEffect(() => {
    setTotalPoints(String(row.score?.totalPoints) ?? '')
  }, [row.score?.totalPoints])

  return (
    <label className="flex items-center gap-1 justify-end">
      <input
        style={{ boxShadow: 'none', outline: 'none' }}
        type="number"
        className={clsx(
          'w-[120px] p-2 rounded-md border-black/10 outline-0 placeholder:text-sm text-sm placeholder-shown:no-underline text-SeabiscuitDark200ThemeColor text-center underline hover:no-underline focus:no-underline cursor-pointer'
        )}
        placeholder="0"
        value={Number(totalPoints) >= 0 ? totalPoints : ''}
        onChange={(event) => setTotalPoints(event.target.value)}
        onBlur={(event) => onBlurTotalPoints(event, row)}
      />
      {row.score?.scoreStatus && (
        <span className="opacity-50 text-[14px]"> • {row.score.scoreStatus}</span>
      )}
    </label>
  )
}
